import { Button, Form, Input } from "antd";
import { Container } from "../../../../shared/base-components/Layouts/Container/Container.styles";
import { Action, Details } from "./TemplateCreate.styles";
import { Flex } from "../../../../shared/base-components/Layouts/Flex/Flex.styles";
import type { DragEndEvent } from "@dnd-kit/core";
import {
  closestCenter,
  DndContext,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import {
  arrayMove,
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { useState } from "react";

import { useNavigate } from "react-router-dom";
import { SheetInfo } from "./Sheet";

export const TemplateCreate = () => {
  const navigate = useNavigate();

  const [dataSource, setDataSource] = useState([
    {
      id: 1,
      menuOrder: 1,
      sheetName: "Partners",
    },
    {
      id: 2,
      menuOrder: 2,
      sheetName: "Income",
      dependency: "CoA",
    },
    {
      id: 3,
      menuOrder: 3,
      sheetName: "Break Periods",
      dependency:
        "Partners, Income, Partners, Income, Partners, Income, Partners, Income, Partners, Income, Partners, Income, Partners, Income, Partners, Income, Partners, Income, Partners, Income, Partners, Income",
    },
  ]);

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 1,
      },
    })
  );

  const onDragEnd = ({ active, over }: DragEndEvent) => {
    if (active.id !== over?.id) {
      setDataSource((prev) => {
        const activeIndex = prev.findIndex((i) => i.id === active.id);
        const overIndex = prev.findIndex((i) => i.id === over?.id);
        let orderedData = arrayMove(prev, activeIndex, overIndex);
        orderedData.forEach((data, index) => (data.menuOrder = index + 1));
        return orderedData;
      });
    }
  };

  return (
    <Container>
      <Flex
        flexDirection="column"
        width="100%"
        height="calc(100vh - 100px)"
        alignItems="stretch"
      >
        <Action>
          <Flex>
            <Form layout="vertical">
              <Form.Item name="name">
                <Input id="template-name" placeholder="Template Name" />
              </Form.Item>
            </Form>
            <Button id="publish-template" type="primary">Publish Template</Button>
          </Flex>
        </Action>
        <Details count={dataSource.length} isHorizontal={false}>
          <Flex>
            <h1>Sheets</h1>
            <Button id="create-sheet"
              type="primary"
              onClick={() => navigate("/template/1/sheet/1")}
            >
              Add New Sheet
            </Button>
          </Flex>
          <DndContext
            sensors={sensors}
            collisionDetection={closestCenter}
            modifiers={[restrictToVerticalAxis]}
            onDragEnd={onDragEnd}
          >
            <SortableContext
              items={dataSource.map((i) => i.id)}
              strategy={verticalListSortingStrategy}
            >
              {dataSource.map((data) => (
                <SheetInfo key={data.id} data={data} />
              ))}
            </SortableContext>
          </DndContext>
        </Details>
      </Flex>
    </Container>
  );
};
